<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/Zpk3QO/d2d_images/cover.jpg?1689979002239" alt="This image is the cover for the book Presa da Tre Guardie del Corpo, Ménage"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Presa da Tre Guardie del Corpo, Ménage
      </h1>
      <p class="bookDescription body article font2">
        <p>La ventunenne Stephanie Stephenson è stata in una casa sicura con tre guardie del corpo sexy per molti mesi. È l’unica testimone di un omicidio e loro la proteggono da Santonio, il boss della mafia, che ha giurato di vendicarsi se lei osa testimoniare. È stato tutto rigorosamente professionale e platonico con le muscolose guardie del corpo. Ora il processo è finito e Stephanie è libera di andarsene. Ma le tre guardie del corpo hanno altri piani per Stephanie… piani molto licenziosi.<br/> Altre storie di Jasmine Black in italiano:<br/> Sedotta da tre motociclisti Impegnata con tre miliardari Impegnata con tre dottori Cavalcata da tre cowboy Presa da due dottori Sedotta da due biker Presa da due miliardari Sedotta da due boss Presa da due personal trainers Presa da due pompieri Sedotta da due falegnami<br/></p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Jasmine Black, Roberto Felletti
      </h2>
      
      <p class="authorDescription body article">Jasmine Black scrive storie erotiche esclusivamente per la Spunky Girl Publishing. Vive a Minden, Ontario (Canada). Le piacciono l’escursionismo, la fotografia, il giardinaggio, leggere e scrivere.<br/></p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Spunky Girl Publishing
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?2138d1af